import React, { useEffect, useState, useRef } from "react";
import { fetch, post } from "../../Util/axios_helper";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  getballRoomMapList,
  onBalMapEdit,
  getFunctionTypesEvent,
  getEventTypes,
  getNoofAttendeesList,
  getBallRoomList,
  onPriorityEditClick,
  onhandleEditClick,
} from "../Email/configuration_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  Button,
  ErrorMsg,
  GetFormData,
  ValidateForm,
  checkAccess,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";

export const BallroomMapping = ({ selTab }) => {
  const dispatch = useDispatch();
  const {
    ballRoomMapList,
    ballroomImgLog,
    ballRoomMapLoaded,
    functionTypesEvent,
    eventType,
    noAttendeesList,
    selFunEvent,
    selAttendees,
    ballroomList,
    showPriorityBallroom,
    showAttendess,
    showEvent,
  } = useSelector((state) => state.configuration);
  const [error, setError] = useState({});
  const [editVisible, setEditVisible] = useState(false);
  const [ballroom, setBallroom] = useState("");
  const [mapPriority, setMapPriority] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [eventError, setEventError] = useState("");
  const [newBallrooms, setNewBallrooms] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(true);
  const [showEventMessage, setShowEventMessage] = useState(true);
  const [showMessage, setShowMessage] = useState(true);
  const [isAddIcon, setIsAddIcon] = useState(true);
  const [Loading, setLoading] = useState(false);

  const modalRef = useRef(null);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  useEffect(() => {
    if (selTab == 4) {
      dispatch(getFunctionTypesEvent());
      dispatch(getballRoomMapList());
      dispatch(getEventTypes());
      dispatch(getNoofAttendeesList());
      dispatch(getBallRoomList());
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setShowMessage(false);
    setShowErrorMessage(false);
    setShowEventMessage(false);
    setError({});
    dispatch(onBalMapEdit(null));
    setNewBallrooms([]);
    setBallroom("");
    setMapPriority("");
    setEditVisible(false);
    dispatch(onPriorityEditClick(true));
    dispatch(onhandleEditClick(true));
    setIsAddIcon(true);
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    if (!newBallrooms || newBallrooms.length == 0) {
      setShowErrorMessage(true);
      setErrorMessage("Add at least one priority");
      setError(err || {});
    } else {
      var err = ValidateForm(e);

      var data = GetFormData(e);
      if (!editVisible) {
        const isBallRoomAttendesNameExists = ballRoomMapList.some(
          (item) =>
            item.BallRoomAttendesIds == data.BallRoomAttendesIds &&
            item.BallRoomEventIds == data.BallRoomEventIds
        );

        if (isBallRoomAttendesNameExists) {
          setShowMessage(true);
          setMessage("No of Attendees already exists for this event type");
          return;
        }
      }

      data.BallMapRoomId = newBallrooms
        .map((ballroom) => ballroom.BallroomId)
        .join(",");
      data.BallroomName = newBallrooms
        .map((ballroom) => ballroom.BallroomName)
        .join(",");
      data.BallRoomPriorityNo = newBallrooms
        .map((ballroom) => ballroom.PriorityId)
        .join(",");
      data.SavedBy = sessionUser();

      if (editVisible && editVisible.visible) {
        data.BallRoomMappingId = editVisible.ballRoomMappingId;
      }

      try {
        setLoading(true);
        if (editVisible && editVisible.visible) {
          await post(
            "Configuration/SaveBallroomMap",
            data,
            true,
            false,
            false,
            true
          );
        } else {
          await post(
            "Configuration/SaveBallroomMap",
            data,
            true,
            true,
            false,
            false
          );
        }
        clearForm();
        $("#ballroom-ballmap-cancel").click();
        dispatch(getballRoomMapList());
      } catch (error) {}
    }
  };

  const handleEditClick = async (e) => {
    dispatch(onPriorityEditClick(true));
    dispatch(onhandleEditClick(false));
    const data = await fetch(
      `Configuration/GetBallRoomMapById?BallRoomMappingId=${e.BallRoomMappingId}`
    );
    dispatch(onBalMapEdit(data));

    let ballRoomPriorityNoArray = e.BallRoomPriorityNo.split(",").map(Number);
    let ballMapRoomIdArray = e.BallMapRoomId.split(",").map(Number);
    let ballRoomNames = e.BallRoomName?.split(",").map(String);
    const initialBallrooms = ballMapRoomIdArray.map((ballRoomId, index) => ({
      BallroomId: ballRoomId,
      BallroomName: ballRoomNames ? ballRoomNames[index] : "",
      PriorityId: ballRoomPriorityNoArray[index],
    }));
    setNewBallrooms(initialBallrooms);

    setEditVisible({
      visible: true,
      ballRoomMappingId: e.BallRoomMappingId,
    });
    const modal = new bootstrap.Modal(document.getElementById("add_ballmap"));
    modal.show();
  };
  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      fetch(
        `Configuration/DeleteBallroomMap?BallRoomMappingId=${e.BallRoomMappingId}`,
        true,
        false,
        true
      ).then(() => {
        dispatch(getballRoomMapList());
      });
    };
    confirmDelete(onDelete);
  };
  const prioritiesData = [
    { PriorityId: 1, Priority: "1" },
    { PriorityId: 2, Priority: "2" },
    { PriorityId: 3, Priority: "3" },
    { PriorityId: 4, Priority: "4" },
    { PriorityId: 5, Priority: "5" },
    { PriorityId: 6, Priority: "6" },
  ];

  const onAddPriority = (e) => {
    e.preventDefault();
    const selFunEvent = $("#BallRoomEventIds").val().trim();
    const selAttendees = $("#BallRoomAttendesIds").val().trim();
    let a = selFunEvent == "";
    let b = selAttendees == "";
    setError((prevError) => ({
      ...prevError,
      BallRoomEventIds: a,
      BallRoomAttendesIds: b,
    }));
    const err = ValidateForm(e);
    setShowErrorMessage(false);

    if (err) {
      setError((prevError) => ({
        ...prevError,
        ...err,
      }));
    } else if (!a && !b) {
      const data = GetFormData(e);
      let ballName = "";
      let temp = ballroomList.find((e) => e.BallroomId == data.BallMapRoomId);
      if (temp) {
        ballName = temp.BallRoomName;
      }

      const newPriority = {
        BallroomId: data.BallMapRoomId,
        BallroomName: ballName,
        PriorityId: data.BallPriorityId,
      };
      const isBallroomExist = newBallrooms.some(
        (item) => item.BallroomId == newPriority.BallroomId
      );

      const isPriorityExist = newBallrooms.some(
        (item) => item.PriorityId == newPriority.PriorityId
      );

      if (isBallroomExist && isPriorityExist) {
        setShowErrorMessage(true);
        setErrorMessage("This ballroom & priority already exists");
      } else {
        if (isBallroomExist) {
          setShowErrorMessage(true);
          setErrorMessage("This ballroom already exists");
        } else if (isPriorityExist) {
          setShowErrorMessage(true);
          setErrorMessage("This priority already exists");
        } else {
          const updatedBallrooms = newBallrooms.map((item) =>
            item.BallroomId == newPriority.BallroomId
              ? { ...item, PriorityId: newPriority.PriorityId }
              : item
          );
          if (
            !newBallrooms.some(
              (item) => item.BallroomId == newPriority.BallroomId
            )
          ) {
            // If BallroomId doesn't exist, add the new priority
            updatedBallrooms.push(newPriority);
          }

          updatedBallrooms.sort((a, b) => a.PriorityId - b.PriorityId);
          setNewBallrooms(updatedBallrooms);
          setMapPriority("");
          setBallroom("");
        }
        setIsAddIcon(true);
      }
    }
  };

  const handlePriorityDeleteClick = (e) => {
    const deleteBallRooms = newBallrooms.filter((item) => {
      return (
        item.BallroomId !== e.BallroomId ||
        item.BallroomName !== e.BallroomName ||
        item.PriorityId !== e.PriorityId
      );
    });

    setNewBallrooms(deleteBallRooms);
  };
  const handlePriorityEditClick = (e) => {
    dispatch(onPriorityEditClick(false));

    setBallroom(e.BallroomId);
    setMapPriority(e.PriorityId);
    setIsAddIcon(false);
  };

  function getBgColor(priority) {
    switch (priority) {
      case "1":
        return "#55ce63";
      case "2":
        return "#7460ee";
      case "3":
        return "#009efb";
      case "4":
        return "#FF9B44";
      case "5":
        return "#ffbc34";
      case "6":
        return "#f62d51";
      default:
        return "#f62d51";
    }
  }
  return (
    <>
      <div className="col-auto ms-auto">
        <div className="row">
          <div className="col-sm-6"></div>
          {checkAccess("APPCONFIGCREATE") && (
            <div className="col-auto float-end ms-auto">
              <div className="d-flex justify-content-end mb-2">
                <Button
                  name={"Add Mapping"}
                  dataBsToggle={"modal"}
                  dataBsTarget={"#add_ballmap"}
                  dataBsDismiss={"modal"}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {!ballRoomMapLoaded ? (
            <div className="row">
              <div className="col-12">
                <KendoLoader />
              </div>
            </div>
          ) : (
            <KendoGrid
              name={"ballmapPri-config"}
              refreshWhen={ballroomImgLog}
              data={ballRoomMapList}
              columns={[
                {
                  field: "BallRoomMappingId",
                  filterable: false,
                  hidden: true,
                },

                {
                  field: "BallRoomEventName",
                  title: "Events",
                  template: "#= kendo.toString(BallRoomEventName) #",
                },
                {
                  field: "BallRoomAttendesName",
                  title: "Attendees",
                },
                {
                  field: "MergedColumn",
                  title: "Ballroom (Priority)",
                  template: function (e) {
                    const ballRoomNames = (e.BallRoomName || "").split(",");
                    const ballRoomPriorities = (
                      e.BallRoomPriorityNo || ""
                    ).split(",");
                    if (ballRoomNames.length == ballRoomPriorities.length) {
                      const merCol = ballRoomNames.map(
                        (ballRoomName, index) => {
                          const priority = ballRoomPriorities[index];
                          return `<div style="display:flex;margin-bottom:2px"> <div style="width:17px;height:17px;font-size:12px;margin-right:4px;text-align:center;color:white;border-radius:100%;background:${getBgColor(
                            priority.trim()
                          )}">${priority.trim()}</div>${ballRoomName.trim()}</div>`;
                        }
                      );
                      return merCol.join("");
                    } else {
                      return "<div></div>";
                    }
                  },
                },
              ]}
              showOptions={
                checkAccess("APPCONFIGEDIT") || checkAccess("APPCONFIGDELETE")
              }
              showEdit={checkAccess("APPCONFIGEDIT")}
              showDelete={checkAccess("APPCONFIGDELETE")}
              onEditClick={handleEditClick}
              onDeleteClick={handleDeleteClick}
              disableExportExcel={true}
            />
          )}
        </div>
      </div>
      {/* <!-- Add Culture Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_ballmap"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Mapping" : "Add Mapping"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-ballmap-config" onSubmit={onSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Event Type <span className="text-danger">*</span>
                    </label>
                    <KendoDropdown
                      name="BallRoomEventIds"
                      data={eventType}
                      placeholder={"Select Event Type"}
                      dataTextField={"TypeName"}
                      dataValueField={"TypeId"}
                      value={selFunEvent}
                      searchable={true}
                      modalID={"#add_ballmap"}
                      onChange={(e) => {
                        setShowEventMessage(false);
                      }}
                      isReadOnly={showEvent}
                      required={true}
                      onValidate={onValidation}
                    />
                    {error.BallRoomEventIds && (
                      <ErrorMsg text="Event type is required" />
                    )}
                    {showEventMessage && <ErrorMsg text={eventError} />}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      No of Attendees <span className="text-danger">*</span>
                    </label>
                    <KendoDropdown
                      name="BallRoomAttendesIds"
                      data={noAttendeesList}
                      placeholder={"Select Attendees..."}
                      dataTextField={"Attendees"}
                      dataValueField={"NoofAttendeesId"}
                      searchable={true}
                      modalID={"#add_ballmap"}
                      value={selAttendees}
                      onChange={(e) => {
                        setShowMessage(false);
                      }}
                      isReadOnly={showAttendess}
                      required={true}
                      onValidate={onValidation}
                    />

                    {error.BallRoomAttendesIds && (
                      <ErrorMsg text="Attendees is required" />
                    )}
                    {showMessage && <ErrorMsg text={message} />}
                  </div>
                </div>

                <button
                  type="submit"
                  id="btn-ballmap-submit"
                  style={{ display: "none" }}
                ></button>
              </form>
              <form id="sub-form" onSubmit={onAddPriority}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Ballroom <span className="text-danger">*</span>
                    </label>
                    <KendoDropdown
                      name="BallMapRoomId"
                      data={ballroomList}
                      placeholder={"Select Ballroom..."}
                      dataTextField={"BallRoomName"}
                      dataValueField={"BallroomId"}
                      searchable={true}
                      modalID={"#add_ballmap"}
                      isReadOnly={showPriorityBallroom}
                      value={ballroom}
                      required={true}
                      onValidate={onValidation}
                      onChange={(e) => {
                        setBallroom(e);
                      }}
                    />
                    {error.BallMapRoomId && (
                      <ErrorMsg text={"Ballroom is required"} />
                    )}
                  </div>

                  <div className="col-md-5 mb-3">
                    <label className="form-label">
                      Priority <span className="text-danger">*</span>
                    </label>
                    <KendoDropdown
                      name="BallPriorityId"
                      data={prioritiesData}
                      placeholder={"Select Priority..."}
                      dataTextField={"Priority"}
                      dataValueField={"PriorityId"}
                      searchable={true}
                      modalID={"#add_ballmap"}
                      value={mapPriority}
                      required={true}
                      onValidate={onValidation}
                      onChange={(e) => {
                        setMapPriority(e);
                      }}
                    />
                    {error.BallPriorityId && (
                      <ErrorMsg text={"Priority is required"} />
                    )}
                  </div>
                  <div className="col-md-1 mb-3 ">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ marginTop: "20px" }}
                      title="Add Priority"
                    >
                      {" "}
                      <i
                        className={
                          isAddIcon
                            ? "las la-plus-circle"
                            : "las la-check-circle"
                        }
                      ></i>
                    </button>
                  </div>
                  {showErrorMessage && <ErrorMsg text={errorMessage} />}
                </div>
                <div>
                  <span className="k-form-error k-invalid-msg">
                    (Note: Only the items added to the grid will be saved.)
                  </span>
                  <KendoGrid
                    name={"pri-config"}
                    disableToolbar={true}
                    paggable={false}
                    data={newBallrooms}
                    columns={[
                      {
                        field: "BallroomId",
                        hidden: true,
                      },
                      {
                        field: "BallroomName",
                        title: "Ballroom Name",
                      },
                      {
                        field: "PriorityId",
                        title: "Priority",
                      },
                    ]}
                    showOptions={true}
                    showEdit={false}
                    onEditClick={(e) => handlePriorityEditClick(e)}
                    onDeleteClick={(e) => handlePriorityDeleteClick(e)}
                  />
                </div>
              </form>
              {Loading ? (
                <KendoLoader className="d-flex justify-content-end align-items-center" />
              ) : (
                <div className="text-end btn-mt">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="ballroom-ballmap-cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button
                    name={editVisible ? "Update" : "Save"}
                    onClick={(e) => {
                      $("#btn-ballmap-submit").click();
                    }}
                  />
                </div>
              )}
              <button
                type="button"
                id="hide"
                style={{ display: "none" }}
                data-bs-dismiss={"modal"}
                onClick={() => {
                  clearForm();
                }}
              ></button>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Culture Modal --> */}
    </>
  );
};
